import BHowFirstRussianBox from './BHowFirstRussianBox'

export default BHowFirstRussianBox
